<template>
    <v-app>
        <v-container class="services" v-if="!hasResult">
            <v-layout xs8 md12 row wrap class="title-block">
                <services-breadcrumbs v-if="b2b"></services-breadcrumbs>
                <v-flex>
                    <h2>Поиск и проверка техосмотра по базе ЕАИСТО</h2>
                </v-flex>
            </v-layout>
            <services-carousel
                v-if="!b2b"
                :slides="carouselSlides"
            />
            <services-request-form
                title="Напомнить об окончании срока действия ТО"
                type="dcard"
                :loading="loading"
                @find="find"
            />
        </v-container>
        <v-container class="services services-result" v-if="hasResult">
            <v-layout xs8 md12 row wrap class="title-block">
                <services-breadcrumbs v-if="b2b"></services-breadcrumbs>
                <v-flex>
                    <h2>Информация о диагностической карте.</h2>
                </v-flex>
            </v-layout>
            <v-layout
                class="service-form service-result-list"
                style="max-width: 1240px"
                v-if="!showMore"
            >
                <v-flex class="service-result-list-item">
                    <div>Номер диагностической карты</div>
                    <div v-html="requestResult.dcardNumber"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Марка и модель</div>
                    <div v-html="requestResult.markModel"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Период действия от – до </div>
                    <div v-html="requestResult.startDate + ' ' + requestResult.endDate"></div>
                </v-flex>
            </v-layout>
            <v-layout
                class="service-form service-result-list"
                style="max-width: 1240px"
                v-if="showMore"
            >
                <v-flex class="service-result-list-item">
                    <div>Номер диагностической карты</div>
                    <div v-html="requestResult.dcardNumber"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Период действия от – до </div>
                    <div v-html="requestResult.startDate + ' - ' + requestResult.endDate"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Пробег</div>
                    <div v-html="requestResult.odometr"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Адрес прохождения ТО</div>
                    <div v-html="requestResult.station"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Марка и модель</div>
                    <div v-html="requestResult.markModel"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Гос. номер</div>
                    <div v-html="requestResult.gosNumber"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>VIN-код</div>
                    <div v-html="requestResult.vin"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Номер кузова</div>
                    <div v-html="requestResult.body"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Номер шасси</div>
                    <div v-html="requestResult.chassis"></div>
                </v-flex>
            </v-layout>
            <v-layout
                class="service-form-button"
                style="max-width: 1240px"
            >
                <v-btn
                    class="button black-button block"
                    @click="showMore = true"
                    v-if="!showMore"
                >
                    Подробнее
                </v-btn>
                <v-btn
                    class="button black-button block"
                    @click="showMore = false"
                    v-if="showMore"
                >
                    Свернуть
                </v-btn>
            </v-layout>
            <services-notification-form
                title="Напомнить об окончании срока действия ТО"
                type="dcard"
                :requestResult="requestResult"
                :requestUrl="'/services/notification/create'"
            />
            <v-layout
                pb-4
                class="service-form-button"
                style="max-width: 1240px"
            >
                <v-btn
                    class="button next-button block"
                    @click="resetResult"
                >
                    Назад
                </v-btn>
            </v-layout>
        </v-container>
        <services-underlist v-if="!b2b" />
        <services-list v-if="!b2b" />
    </v-app>
</template>
<script>
    import _ from 'lodash';
    import ServicesBreadcrumbs from "./ServicesBreadcrumbs";

    export default {
        components: {'services-breadcrumbs': ServicesBreadcrumbs},
        props: {
            b2b: {
                default: false
            }
        },
        data: () => ({
            loading: false,
            hasResult: false,
            requestResult: {
                dcardNumber: null,
                startDate: null,
                endDate: null,
                markModel: null,
                odometr: null,
                station: null,
                body: null,
                vin: null,
                gosNumber: null,
                chassis: null,
            },
            requestResultDefault: {},
            showMore: false,
            carouselSlides: [
                'Найдите информацию о действующей диагностической карте по гос. номеру или VIN автомобиля. Напомним заранее об окончании срока действия',
                'Вы больше не забудете пройти техосмотр вовремя.',
                'Проверьте диагностическую карту на подлинность, есть ли она в базе ЕАИСТО.'
            ],
        }),
        created() {
            this.requestResultDefault = _.cloneDeep(this.requestResult)
        },
        methods: {

            find(data) {
                this.loading = true
                try {
                    grecaptcha.ready(() => {
                        grecaptcha.execute(
                            Vue.GetpolisConstants.RECAPTCHA_SITEKEY,
                            {action: Vue.GetpolisConstants.RECAPTCHA_ACTIONS.DCARD}
                        ).then(token => {
                            data.r = token
                            axios.post('/services/getdcard', data)
                            .then(response => {
                                this.hasResult = true
                                this.requestResult = response.data
                                window.scrollTo(0,0);
                            })
                            .catch(error => {
                                console.log(error)
                                PNotify.error(error.response.data.message);
                            })
                            .finally(() => {
                                this.$nextTick(() => {
                                    this.loading = false
                                })
                            })
                        });
                    })
                } catch (e) {
                    console.log(e);
                }
            },

            resetResult() {
                this.requestResult = _.cloneDeep(this.requestResultDefault)
                this.showMore = false
                this.hasResult = false
                window.scrollTo(0,0);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/services/ServiceDcardPage.vue